import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { ComponentPropsWithoutRef, useMemo, useState } from 'react';

interface IProps extends ComponentPropsWithoutRef<typeof Avatar> {
  address: string;
  logo: string;
}

export default (props: IProps) => {
  const { address, logo, ...attr } = props;

  const spareImgSrc = `https://dd.dexscreener.com/ds-data/tokens/solana/${address}.png?size=lg&key=8fb405`;
  const [imgSrc, setImgSrc] = useState(`https://api.degencdn.com/v1/nfts/${address}/image.png`);

  const processedLogo = useMemo(() => {
    if (!logo) return `https://api.degencdn.com/v1/nfts/${address}/image.png`;

    if (logo.startsWith('https://ipfs.io/ipfs/')) {
      const tokenAddress = logo.replace('https://ipfs.io/ipfs/', '');
      return `https://pump.mypinata.cloud/ipfs/${tokenAddress}?img-width=30&img-dpr=2&img-onerror=redirect`;
    }
    return logo;
  }, [logo, address]);

  const onLoadingStatusChange = (e: 'idle' | 'loading' | 'loaded' | 'error') => {
    if (e == 'error') {
      setImgSrc(spareImgSrc);
    }
  };
  return (
    <Avatar {...attr}>
      <AvatarImage src={processedLogo || imgSrc} onLoadingStatusChange={onLoadingStatusChange} />
      <AvatarFallback>
        <img src="/icon/default_logo.svg" />
      </AvatarFallback>
    </Avatar>
  );
};
